import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { getByDCSNamespace } from '../../services/ruutsApi/findings/getByDCS'
import { resolveFinding } from '../../services/ruutsApi/findings/resolveFinding'
import { saveFinding } from '../../services/ruutsApi/findings/saveFinding'
import { queryKeys } from './queryKeys'

export const findingsQueryOptions = ({
  dcsId,
  namespace,
  resolved,
}: {
  dcsId: string
  namespace: string
  resolved: boolean
}) =>
  queryOptions({
    queryKey: queryKeys.findings(dcsId, namespace, resolved),
    queryFn: ({ signal }) =>
      getByDCSNamespace({ dataCollectionStatementId: dcsId, namespace, resolved, signal }),
  })

// Findings render inside the metric events they observe, so both reads go stale together.
// Not awaited: FormContainer's handleMetricReset re-invalidates the open form's metric events right
// after, and an awaited refetch would be followed by a second one.
const useInvalidateFindings = () => {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.findingsRoot })
    queryClient.invalidateQueries({ queryKey: queryKeys.metricEventsRoot })
  }
}

export const useSaveFinding = () => {
  const invalidateFindings = useInvalidateFindings()
  return useMutation({
    mutationFn: saveFinding,
    // DataCollectionDynamicForm reports the failure through its loading modal.
    meta: { suppressGlobalError: true },
    onSuccess: invalidateFindings,
  })
}

export const useResolveFinding = () => {
  const invalidateFindings = useInvalidateFindings()
  return useMutation({
    mutationFn: resolveFinding,
    meta: { suppressGlobalError: true },
    onSuccess: invalidateFindings,
  })
}
